import { createStyles, Theme } from '@material-ui/core/styles';
import zIndex from '@material-ui/core/styles/zIndex';
import {
  bodyText,
  h5,
  h7,
  h8,
  shadows,
  spacing,
} from '#web-components/styles';

const styles = (theme: Theme) => createStyles({
  root: {
    ...h8,
    display: 'flex',
    borderRadius: 2,
    padding: spacing * 2,
    marginBottom: spacing * 3,
    position: 'relative',
    zIndex: zIndex.snackbar,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  alignCenter: {
    alignItems: 'center',
  },
  plain: {
    padding: spacing * 3,
    zIndex: 1,
    '& $title': {
      ...h5,
    },
    '& $message': {
      marginTop: spacing * 1.5,
    },
  },
  plainMessage: {
    ...bodyText,
  },
  notification: {
    boxShadow: shadows.notification,
    width: 392,
  },
  error: {
    backgroundColor: theme.colors.uIRedBackground,
  },
  warning: {
    backgroundColor: theme.colors.uIYellowBackground,
  },
  success: {
    backgroundColor: theme.colors.uIGreenBackground,
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: spacing * 2,
    wordWrap: 'break-word',
    overflowWrap: 'anywhere',
  },
  title: {
    ...h7,
  },
  message: {
    marginTop: spacing,
  },
  close: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    background: 'none',
    border: 'none',
    outline: 'none',
    margin: '-8px -8px 0 0',
    '&:hover': {
      cursor: 'pointer',
      background: theme.colors.uIIconHoverArea,
      borderRadius: '50%',
    },
  },
  button: {
    marginTop: spacing * 2,
    '& button': {
      width: '100%',
      backgroundColor: 'transparent',
      backgroundImage: 'none',
      border: `2px solid ${theme.colors.uIBase}`,
      '&:hover': {
        backgroundColor: theme.colors.uIIconHoverArea,
        backgroundImage: 'none',
        border: `2px solid ${theme.colors.uIBase}`,
      },
      '& span': {
        paddingTop: 1.5 * spacing,
        paddingBottom: 1.5 * spacing,
      },
    },
  },
});

export default styles;
